#@import Booking.Views.Base
#@import Booking.Views.PickerNotice
#@export Booking.Views.Picker

class Booking.Views.Picker extends Booking.Views.Base

  templateName: 'picker'

  expandedClassName: 'expanded'

  collapsedClassName: 'collapsed'

  styleClassName: ''

  transitionDuration: 300

  _valid: true

  events:
    'click .dropdown': 'toggle'

  canRender: ->
    true

  className: ->
    "picker #{@collapsedClassName} #{@styleClassName}"

  constructor: ->
    Booking.Views.Base.apply this, arguments

    # When the collection starts loading, clear the selection
    @listenTo @collection, 'reset', => @clearSelection()
    @listenTo @collection, 'request', => @clearSelection()

    # If there's an error in the collection, show an error notice
    @listenTo @collection, 'error', (error) => @showNotice(error)

    # If the model is changed somewhere, update the views
    for attribute in @options.pickerAttributes || []
      do (attribute) =>
        @listenTo @model, "change:#{attribute}", => @optionSelected(attribute)

  optionSelected: (attribute) ->
    @content().render()
    @render()

  detachContent: ->
    @content().$el.detach()

  attachContent: ->
    @content().$el.appendTo @container()
    @content().delegateEvents()

  render: ->

    @detachContent()

    Booking.Views.Base::render.apply this, arguments

    @attachContent()

    @prefill()

    this

  prefill: ->
    @setSelection(@collection.first()) if not @isSelectable() and @collection.first()

  setSelection: (selection) ->
    throw new Error 'Should implement setSelection'

  select: (selection, silent = false) ->
    @setSelection(selection)
    @trigger 'picker:selected', {picker: this, selection} unless silent
    @hideInvalid()

  selected: ->
    throw new Error 'Should implement selected'

  isLoading: ->
    false

  show: ->
    return false if @isVisible()
    @hideDisable()
    @redraw()
    @trigger 'picker:expand', {picker: this}

    transitionEndHandler = =>
      @trigger 'picker:expanded', {picker: this}

    setTimeout(transitionEndHandler, @transitionDuration)
    @$el.removeClass(@collapsedClassName).addClass(@expandedClassName)
    @showHideValidation()

    return true

  hide: (force) ->
    return false if not @isVisible()

    @redraw()
    @trigger 'picker:collapse', {picker: this}

    transitionEndHandler = =>
      @trigger 'picker:collapsed', {picker: this}
      @$el.addClass(@collapsedClassName)

    setTimeout(transitionEndHandler, @transitionDuration)
    @$el.removeClass(@expandedClassName)

    return true

  toggle: ->
    if @isSelectable()
      if @isVisible()
        @hide()
      else
        @show()

  hideNotice: ->
    return unless @notice
    @notice.remove()
    @notice = undefined

  showNotice: (notice) ->
    @notice?.remove()
    @notice = new Booking.Views.PickerNotice {notice}
    @container().prepend(@notice.render().el)
    @notice.open()

  clearSelection: ->
    @content().render()

  isSelectable: ->
    @collection.length > 1

  content: ->
    unless @_content
      @_content = new @contentView
        collection: @collection
        model: @model

      @listenTo @_content, 'picker:select', @select
      @_content.render()

    @_content

  isVisible: ->
    @$el.hasClass(@expandedClassName)

  isValid: ->
    @_valid

  showInvalid: ->
    @_valid = false
    @$('.wrapper').addClass('invalid')

  hideInvalid: ->
    @_valid = true
    @$('.wrapper').removeClass('invalid')

  showHideValidation: ->
    if @isValid() then @hideInvalid() else @showInvalid()

  shouldShowInvalid: ->
    not @selected()

  # Will not test for now
  container: ->
    @$el.find('.content')

  showDisable: ->
    @$('.wrapper').addClass('disabled')

  hideDisable: ->
    @$('.wrapper').removeClass('disabled')

  redraw: ->
    # this method is used to fix css transitions issues.
    # see http://blog.alexmaccaw.com/css-transitions section "Redrawing"
    @$el.get(0).offsetHeight

